import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button, Typography } from '@mui/material';

import {getUrlZoho, setZohoParams, sreatBuckup} from '../api/authZoho';

const AuthZoho = () => {

    const [zohoUrl, setZohoUrl] = useState(null);
    const [backupStatus, setBackupStatus] = useState(null);

    const location = useLocation();

    const handelBackup = async () => {
        const response = await sreatBuckup();
        if (response) {
            setBackupStatus(response.data);
        } else {
            setBackupStatus('Failed to create backup');
        }
    };

    useEffect(() => {
        // console.log('location', location.search);

        if (location.search) {
            const searchParams = new URLSearchParams(location.search);
            const code = searchParams.get('code');
            const state = searchParams.get('state');

            if (code && state) {
                // Handle the code and state as needed
                console.log('Code:', code);
                console.log('State:', state);

                // Example: Set Zoho parameters
                setZohoParams({ code, state });
            }
        }

    }, []);



    useEffect(() => {
        const fetchZohoUrl = async () => {
            const url = await getUrlZoho();
            if (url) {
                // window.location.href = url;
                console.log('Zoho URL:', url);
                setZohoUrl(url.data);
            } else {
                console.error('Failed to fetch Zoho URL');
            }
        };
        fetchZohoUrl();
    }, []);
    return (
        <div>

        {/* <Link to={"https://accounts.zoho.com/oauth/v2/auth?scope=WorkDrive.files.ALL&client_id=11000.03NSG1LR09MKD9CFIR5302NM6RTKYX&response_type=code&access_type=offline&redirect_uri=https://tms.geoship.fr/zoho_work_drive/&state=register"}>
            https://accounts.zoho.com/oauth/v2/auth?scope=WorkDrive.files.ALL&client_id=11000.03NSG1LR09MKD9CFIR5302NM6RTKYX&response_type=code&access_type=offline&redirect_uri=https://tms.geoship.fr/zoho_work_drive/&state=register
        </Link> */}

        <Link to={zohoUrl}>
            {zohoUrl ? zohoUrl : 'Loading Zoho URL...'}
        </Link>

        <Button variant="contained" onClick={handelBackup} style={{ marginTop: '20px' }}>
            Create Backup
        </Button>

        <Typography variant="body1" style={{ marginTop: '20px' }}>
            {backupStatus ? `Backup Status: ${JSON.stringify(backupStatus)}` : 'No backup created yet.'}
        </Typography>

        </div>
    );
}

export default AuthZoho;


